export default "__VITE_ASSET__DawW9GOA__"